import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';


/**
 * Custom Boolean Field to display the value as a colored checkmark or X icon.
 * 
 * @param {Object} props - The properties passed to the component.
 * @param {Object} props.record - The record containing the field's value.
 * @param {string} props.source - The field's name in the record.
 * @param {string} props.falseColor - The color for false values. Defaults to red.
 * @param {string} props.trueColor - The color for true values. Defaults to "#1DD317".
 * @returns {React.Element} A colored checkmark or X icon based on the boolean value.
 */
const ColoredBooleanField = ({ record, source, falseColor = "red", trueColor = "#1DD317" }) => {
    const value = record[source];
    const IconComponent = value ? CheckIcon : CloseIcon;
    const color = value ? trueColor : falseColor;

    return (
        <IconComponent 
            style={{
                color: color,
                marginLeft: '10px'
            }}
        />
    );
};

export default ColoredBooleanField;